/**
 * THE WORDS THE IN-APP MESSAGE OVERLAY WRITES ITSELF (D-92's light-only surfaces: the overlay, part 1).
 *
 * Every other word on a message is the message's own: its body (the planner's, stored by send_platform_message_to_user)
 * and its buttons' labels, sent with it. These four the overlay writes, moved verbatim from today's overlay
 * (InAppMessageOverlay.tsx), lowercase as it wrote them. One module for both designs, so today's overlay and the new
 * design's (src/design/pavilion/appmessages/) cannot say different things; the hook (src/hooks/inAppMessages/) asks the
 * browser's own confirm box with the last.
 */
export const IN_APP_MESSAGE_WORDS = {
  /** What a message's inline form says in its field until the person types (its "form" action opens it). */
  formPlaceholder: 'enter details',
  submit: 'submit',
  cancel: 'cancel',
  /** The browser's own confirm box, before a "confirm" action is sent. */
  confirm: 'are you sure?',
} as const;
